<template>
    <div class="container mb-5">
        <p class="fw-bold fs-2 mb-3">ข้อมูลสำคัญทางการเงิน</p>
        <div class="accordion" id="accordionExample">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                        aria-expanded="true" aria-controls="collapseOne">
                        <div class="row">
                            <div class="col-4 col-md-auto text-start">
                                <img src="../../assets/financial-icon/icon-income.png" class="mb-1">
                            </div>
                            <div class="col-8 col-md-auto">
                                <div class="text-start mb-2">{{ $t('FinancialInfoHome.incomeTitle') }} Q4 / 2567</div>
                                <h4><b>2,347 {{ $t('FinancialInfoHome.MillionBaht') }}</b></h4>
                            </div>
                        </div>
                    </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <div class="container justify-content-center text-center">
                            <ul class="nav nav-pills justify-content-center mb-3" id="pills-tab-mobile" role="tablist">
                                <!-- Tab for Quarter -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="pills-income-quarter-mobile-tab"
                                        data-bs-toggle="pill" data-bs-target="#income-quarter-mobile" type="button"
                                        role="tab" aria-controls="income-quarter-mobile" aria-selected="true">
                                        {{ $t('FinancialInfoHome.quarterLabel') }}
                                    </button>
                                </li>
                                <!-- Tab for Yearly -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="pills-income-yearly-mobile-tab" data-bs-toggle="pill"
                                        data-bs-target="#income-yearly-mobile" type="button" role="tab"
                                        aria-controls="income-yearly-mobile" aria-selected="false">
                                        {{ $t('FinancialInfoHome.yearlyLabel') }}
                                    </button>
                                </li>
                            </ul>

                            <div class="tab-content" id="pills-tabContent-mobile" style="background-color: #F2F2F2;">
                                <!-- Tab content for Income Quarter (Mobile) -->
                                <div class="tab-pane fade show active" id="income-quarter-mobile" role="tabpanel"
                                    aria-labelledby="pills-income-quarter-mobile-tab" tabindex="0">
                                    <div ref="chartQuarteContainerMobile" class="" style="height: 380px;"></div>
                                </div>

                                <!-- Tab content for Income Yearly (Mobile) -->
                                <div class="tab-pane fade" id="income-yearly-mobile" role="tabpanel"
                                    aria-labelledby="pills-income-yearly-mobile-tab" tabindex="0">
                                    <div ref="chartYearlyContainerMobile" class="" style="height: 380px;"></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <div class="row">
                            <div class="col-4 col-md-auto text-start">
                                <img src="../../assets/financial-icon/icon-profit.png" class="mb-1">
                            </div>
                            <div class="col-8 col-md-auto">
                                <div class="text-start mb-2">{{ $t('FinancialInfoHome.profitTitle') }}  Q4 / 2567</div>
                                <h4><b>-266 {{ $t('FinancialInfoHome.MillionBaht') }}</b></h4>
                            </div>
                        </div>
                    </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <div class="container justify-content-center text-center">
                            <ul class="nav nav-pills justify-content-center mb-3" id="pills-tab-mobile" role="tablist">
                                <!-- Tab for Quarter (Profit) -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="pills-profit-quarter-mobile-tab"
                                        data-bs-toggle="pill" data-bs-target="#profit-quarter-mobile" type="button"
                                        role="tab" aria-controls="profit-quarter-mobile" aria-selected="true">
                                        {{ $t('FinancialInfoHome.quarterLabel') }}
                                    </button>
                                </li>
                                <!-- Tab for Yearly (Profit) -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="pills-profit-yearly-mobile-tab" data-bs-toggle="pill"
                                        data-bs-target="#profit-yearly-mobile" type="button" role="tab"
                                        aria-controls="profit-yearly-mobile" aria-selected="false">
                                        {{ $t('FinancialInfoHome.yearlyLabel') }}
                                    </button>
                                </li>
                            </ul>

                            <div class="tab-content" id="pills-tabContent-mobile" style="background-color: #F2F2F2;">
                                <!-- Tab content for Profit Quarter (Mobile) -->
                                <div class="tab-pane fade show active" id="profit-quarter-mobile" role="tabpanel"
                                    aria-labelledby="pills-profit-quarter-mobile-tab" tabindex="0">
                                    <div ref="chartProfitQuarterContainerMobile" class="" style="height: 380px;"></div>
                                </div>

                                <!-- Tab content for Profit Yearly (Mobile) -->
                                <div class="tab-pane fade" id="profit-yearly-mobile" role="tabpanel"
                                    aria-labelledby="pills-profit-yearly-mobile-tab" tabindex="0">
                                    <div ref="chartProfitYearlyContainerMobile" class="" style="height: 380px;"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <div class="row">
                            <div class="col-4 col-md-auto text-start">
                                <img src="../../assets/financial-icon/icon-presale.png" class="mb-1">
                            </div>
                            <div class="col-8 col-md-auto">
                                <div class="text-start mb-2">Presale Q4 / 2567</div>
                                <h4><b>8,593 {{ $t('FinancialInfoHome.MillionBaht') }}</b></h4>
                            </div>
                        </div>
                    </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <div class="container justify-content-center text-center">
                            <ul class="nav nav-pills justify-content-center mb-3" id="pills-tab-mobile" role="tablist">
                                <!-- Tab for Quarter (Presale) -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="pills-presale-quarter-mobile-tab"
                                        data-bs-toggle="pill" data-bs-target="#presale-quarter-mobile" type="button"
                                        role="tab" aria-controls="presale-quarter-mobile" aria-selected="true">
                                        {{ $t('FinancialInfoHome.quarterLabel') }}
                                    </button>
                                </li>
                                <!-- Tab for Yearly (Presale) -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="pills-presale-yearly-mobile-tab" data-bs-toggle="pill"
                                        data-bs-target="#presale-yearly-mobile" type="button" role="tab"
                                        aria-controls="presale-yearly-mobile" aria-selected="false">
                                        {{ $t('FinancialInfoHome.yearlyLabel') }}
                                    </button>
                                </li>
                            </ul>

                            <div class="tab-content" id="pills-tabContent-mobile" style="background-color: #F2F2F2;">
                                <!-- Tab content for Presale Quarter (Mobile) -->
                                <div class="tab-pane fade show active" id="presale-quarter-mobile" role="tabpanel"
                                    aria-labelledby="pills-presale-quarter-mobile-tab" tabindex="0">
                                    <div ref="chartPresaleQuarterContainerMobile" class="" style="height: 380px;"></div>
                                </div>

                                <!-- Tab content for Presale Yearly (Mobile) -->
                                <div class="tab-pane fade" id="presale-yearly-mobile" role="tabpanel"
                                    aria-labelledby="pills-presale-yearly-mobile-tab" tabindex="0">
                                    <div ref="chartPresaleYearlyContainerMobile" class="" style="height: 380px;"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!-- <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        <div class="row">
                            <div class="col-md-auto text-start">
                                <img src="../../assets/financial-icon/icon-backlog.png" class="mb-1">
                            </div>
                            <div class="col-md-auto">
                                <div class="text-start mb-2">Bcaklog Q2 / 2567</div>
                                <h4><b>47,135 ล้านบาท</b></h4>
                            </div>
                        </div>
                    </button>
                </h2>
                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <strong>This is the third item's accordion body.</strong> It is hidden by default, until the
                        collapse plugin adds the appropriate classes that we use to style each element. These classes
                        control the overall appearance, as well as the showing and hiding via CSS transitions. You can
                        modify any of this with custom CSS or overriding our default variables. It's also worth noting that
                        just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit
                        overflow.
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import Highcharts from 'highcharts';

export default {
    name: 'FinancialInforHome',
    props: {
        title: String,
        incomeTitle: String,
        incomeValue: String,
        profitTitle: String,
        profitValue: String,
        presaleTitle: String,
        presaleValue: String,
        backlogTitle: String,
        quarterLabel: String,
        yearlyLabel: String,
        quarterName: String,
        MillionBaht:String
    },
    components: {},
    data() {
        return {
            IncomeQuarterData: [
                { year_1: "2471", year_2: "3213", year_3: "3437", year_4: "2988", year_5: "2347" },
            ],

            IncomeYearlyData: [
                { year_1: "11114", year_2: "15943", year_3: "15741", year_4: "15157", year_5: "11985" },
            ],

            ProfitQuarterData: [
                { year_1: "47", year_2: "464", year_3: "452", year_4: "402", year_5: "-266" },
            ],

            ProfitYearlyData: [
                { year_1: "2662", year_2: "3194", year_3: "3775", year_4: "2718" , year_5: "1052"},
            ],

            PresaleQuarterData: [
                { year_1: "10330", year_2: "8139", year_3: "10192",year_4: "8518", year_5: "8593"  },
            ],

            PresaleYearlyData: [
                { year_1: "25774", year_2: "30257", year_3: "41032", year_4: "47267" , year_5: "35442" },
            ],

        };
    },
    methods: {},
    async mounted() {
        this.IncomeQuarter = [
            parseFloat(this.IncomeQuarterData[0]?.year_1),
            parseFloat(this.IncomeQuarterData[0]?.year_2),
            parseFloat(this.IncomeQuarterData[0]?.year_3),
            parseFloat(this.IncomeQuarterData[0]?.year_4),
            parseFloat(this.IncomeQuarterData[0]?.year_5),
        ];

        this.IncomeYearly = [
            parseFloat(this.IncomeYearlyData[0]?.year_1),
            parseFloat(this.IncomeYearlyData[0]?.year_2),
            parseFloat(this.IncomeYearlyData[0]?.year_3),
            parseFloat(this.IncomeYearlyData[0]?.year_4),
            parseFloat(this.IncomeYearlyData[0]?.year_5),
        ];

        this.ProfitQuarter = [
            parseFloat(this.ProfitQuarterData[0]?.year_1),
            parseFloat(this.ProfitQuarterData[0]?.year_2),
            parseFloat(this.ProfitQuarterData[0]?.year_3),
            parseFloat(this.ProfitQuarterData[0]?.year_4),
            parseFloat(this.ProfitQuarterData[0]?.year_5),
        ];

        this.ProfitYearly = [
            parseFloat(this.ProfitYearlyData[0]?.year_1),
            parseFloat(this.ProfitYearlyData[0]?.year_2),
            parseFloat(this.ProfitYearlyData[0]?.year_3),
            parseFloat(this.ProfitYearlyData[0]?.year_4),
            parseFloat(this.ProfitYearlyData[0]?.year_5),
        ];

        this.PresaleQuarter = [
            parseFloat(this.PresaleQuarterData[0]?.year_1),
            parseFloat(this.PresaleQuarterData[0]?.year_2),
            parseFloat(this.PresaleQuarterData[0]?.year_3),
            parseFloat(this.PresaleQuarterData[0]?.year_4),
            parseFloat(this.PresaleQuarterData[0]?.year_5),
        ];

        this.PresaleYearly = [
            parseFloat(this.PresaleYearlyData[0]?.year_1),
            parseFloat(this.PresaleYearlyData[0]?.year_2),
            parseFloat(this.PresaleYearlyData[0]?.year_3),
            parseFloat(this.PresaleYearlyData[0]?.year_4),
            parseFloat(this.PresaleYearlyData[0]?.year_5),
        ];

        Highcharts.chart(this.$refs.chartQuarteContainerMobile, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['Q4/66', 'Q1/67', 'Q2/67', 'Q3/67',' Q4/67'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.IncomeQuarter.map((value, index) => ({
                        y: value,
                        color: index === this.IncomeQuarter.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });

        Highcharts.chart(this.$refs.chartYearlyContainerMobile, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['2563', '2564', '2565', '2566', '2567'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.IncomeYearly.map((value, index) => ({
                        y: value,
                        color: index === this.IncomeYearly.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });

        Highcharts.chart(this.$refs.chartProfitQuarterContainerMobile, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['Q4/66', 'Q1/67', 'Q2/67', 'Q3/67',' Q4/67'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.ProfitQuarter.map((value, index) => ({
                        y: value,
                        color: index === this.ProfitQuarter.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });

        Highcharts.chart(this.$refs.chartProfitYearlyContainerMobile, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['2563', '2564', '2565', '2566', '2567'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.ProfitYearly.map((value, index) => ({
                        y: value,
                        color: index === this.ProfitYearly.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });

        Highcharts.chart(this.$refs.chartPresaleQuarterContainerMobile, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['Q4/66', 'Q1/67', 'Q2/67', 'Q3/67',' Q4/67'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.PresaleQuarter.map((value, index) => ({
                        y: value,
                        color: index === this.PresaleQuarter.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });


        Highcharts.chart(this.$refs.chartPresaleYearlyContainerMobile, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['2563', '2564', '2565', '2566', '2567'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.PresaleYearly.map((value, index) => ({
                        y: value,
                        color: index === this.PresaleYearly.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });
    }
};

</script>

<style>
.accordion-body {
    background-color: #F2F2F2;
}
</style>

